/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {filterPlaceholderCustomers} from '../api'

export const useMutationFilterPlaceholderCustomers = createReactQueryMutationHook('filterPlaceholderCustomers', filterPlaceholderCustomers)
